import * as React from 'react';
export const BikeleasingATIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    version="1.1"
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 446.7 38.3"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {`
      .st0 { display: none; }
      .st1 { display: inline; }
      .st2 { fill: #95C11E; }
    `}
    </style>
    <g className="st0">
      <g className="st1">
        <path
          className="st2"
          d="M16.6,14.6c-0.4,0-0.7,0.2-0.9,0.5c0,0,0,0.1-0.1,0.2c0,0.1,0,0.2,0,0.2c0,0.5,0.4,1,0.9,1
			c0.4,0,0.8-0.3,0.9-0.7c0-0.1,0-0.2,0-0.2c0-0.2-0.1-0.5-0.2-0.7C17.1,14.8,16.8,14.6,16.6,14.6z"
        />
        <path
          className="st2"
          d="M16.5,20.7c-0.4,0-0.8,0.3-0.9,0.7c0,0.1,0,0.2,0,0.2c0,0.2,0,0.4,0.2,0.5c0.2,0.3,0.5,0.4,0.8,0.4
			c0.2,0,0.4-0.1,0.6-0.2s0.3-0.3,0.3-0.5c0-0.1,0-0.2,0-0.2C17.4,21.2,17,20.8,16.5,20.7z"
        />
        <path
          className="st2"
          d="M53.2,29.9h-3.5V17.6V8.7H53c1.3,0,1.6-0.6,1.6-1.6V2.6c0-1-0.3-1.6-1.6-1.6H37.5c-1.3,0-1.6,0.6-1.6,1.6v4.5
			c0,1,0.3,1.6,1.6,1.6h3.4v7.9v13.3h-3.5c-1.3,0-1.6,0.6-1.6,1.6V36c0,1,0.3,1.6,1.6,1.6h15.8c1.3,0,1.6-0.6,1.6-1.6v-4.4
			C54.8,30.5,54.4,29.9,53.2,29.9z"
        />
        <path
          className="st2"
          d="M92.4,0.9h-7.5c-1.3,0-1.7,0.1-2.8,1.3L70.6,15V2.6C70.6,1.3,70,1,69.1,1h-5.5C62.5,1,62,1.3,62,2.6v16.1
			v17.2c0,1.3,0.6,1.6,1.6,1.6h5.5c0.9,0,1.6-0.3,1.6-1.6V26l3.4-3.6c3,5,8,13.4,8,13.4c0.7,1.2,1.4,1.8,2.8,1.8h6.8
			c1.1,0,1.3-1.1,0.8-1.8L83,20.3l-2.6-4.2L93,2.5C93.5,2,93.5,0.9,92.4,0.9z"
        />
        <path
          className="st2"
          d="M123.7,29.8H106v-7.3h14.9c0.4,0,0.7-0.1,0.9-0.2c0.5-0.2,0.7-0.8,0.7-1.4v-4.3c0-1-0.3-1.6-1.6-1.6H106V8.8
			h16.8c1.3,0,1.6-0.6,1.6-1.6V2.6c0-1-0.3-1.6-1.6-1.6h-24c-1.3,0-1.6,0.6-1.6,1.6v18.6V36c0,1,0.3,1.6,1.6,1.6h24.9
			c1.3,0,1.6-0.6,1.6-1.6v-4.6C125.3,30.4,125,29.8,123.7,29.8z"
        />
        <path
          className="st2"
          d="M156.8,29.8h-16v-6.9V2.6c0-1.3-0.6-1.6-1.6-1.6h-5.5c-1,0-1.6,0.3-1.6,1.6v20v13.3c0,1,0.3,1.6,1.6,1.6h23.1
			c1.3,0,1.6-0.6,1.6-1.6v-4.6C158.4,30.4,158.1,29.8,156.8,29.8z"
        />
        <path
          className="st2"
          d="M191,29.8h-17.8v-6.4v-1h14.9c1.3,0,1.6-0.6,1.6-1.6v-4.3c0-1-0.3-1.6-1.6-1.6h-14.9V8.8H190
			c1.3,0,1.6-0.6,1.6-1.6V2.6c0-1-0.3-1.6-1.6-1.6h-24c-1.3,0-1.6,0.6-1.6,1.6v20.7V36c0,1,0.3,1.6,1.6,1.6h25
			c1.3,0,1.6-0.6,1.6-1.6v-4.6C192.6,30.4,192.3,29.8,191,29.8z"
        />
        <path
          className="st2"
          d="M230.8,36L226,23l-7.5-20.4c-0.5-1.1-1-1.6-2.3-1.6h-5.3c-1.2,0-1.8,0.6-2.3,1.7L201,23.4L196.3,36
			c-0.3,0.7-0.3,1.6,0.9,1.6h5.8c1.2,0,1.7-0.3,2.1-1.7l1.6-4.4h13.6l1.6,4.4c0.4,1.3,0.9,1.7,2.1,1.7h5.8
			C231.1,37.6,231.1,36.7,230.8,36z M213.6,11.4l4,11.8l-8,0.1L213.6,11.4z"
        />
        <path
          className="st2"
          d="M261.7,21.7c-1.8-3.4-5.6-4.5-8.5-5.4c-2.1-0.8-10-2-10-5.3c0-2.4,2.9-3.1,4.7-3.1c1.6,0,3.5,0.5,4.5,1.4
			c0.6,0.6,0.9,1.1,1.1,1.6c0.3,0.7,0.4,1.4,1.4,1.4h5.2c1.2,0,1.5-0.2,1.5-1.5c0-7-7.4-10.1-14.2-10.1c-6.7,0.3-13,3.7-13,10.6
			c0,6.8,5,8.9,10.4,10.6c0.3,0.1,0.5,0.2,0.8,0.2c4.3,1.2,8.5,1.4,8.5,4.2c0,3-2.4,3.6-5.2,3.6c-2,0-4.2-0.5-5.2-1.8
			c-0.7-0.8-1-1.5-1-2.2c-0.1-1.3-0.7-1.5-1.9-1.5h-5.2c-1.2,0-1.6,0.3-1.6,1.5c0,7.5,7.7,11.3,14.4,11.3c8.2,0,14.2-3.6,14.2-11.2
			C262.7,24.4,262.3,22.9,261.7,21.7z"
        />
        <path
          className="st2"
          d="M285.9,29.9h-3.5v-9V8.7h3.3c1.3,0,1.6-0.6,1.6-1.6V2.6c0-1-0.3-1.6-1.6-1.6h-15.5c-1.3,0-1.6,0.6-1.6,1.6
			v4.5c0,1,0.3,1.6,1.6,1.6h3.4v12.7V30h-3.5c-1.3,0-1.6,0.6-1.6,1.6V36c0,1,0.3,1.6,1.6,1.6h15.8c1.3,0,1.6-0.6,1.6-1.6v-4.4
			C287.5,30.5,287.2,29.9,285.9,29.9z"
        />
        <path
          className="st2"
          d="M322.8,0.9h-5.3c-1,0-1.6,0.3-1.6,1.6v15.9v3.4l-2-3.2L304,2.8c-0.7-1.1-1.1-1.9-2.5-1.9h-5.2
			c-1.3,0-1.6,0.6-1.6,1.6v17.6v15.8c0,1.3,0.6,1.6,1.6,1.6h5.5c1,0,1.6-0.3,1.6-1.6V19.5v-2.9l1.7,2.8l10.1,16.3
			c0.7,1.1,1.1,1.9,2.5,1.9h5.1c1.3,0,1.6-0.6,1.6-1.6V17.7V2.6C324.4,1.3,323.8,0.9,322.8,0.9z"
        />
        <path
          className="st2"
          d="M358.7,17H347c-1.2,0-1.5,0.6-1.5,1.5v4.2c0,1,0.3,1.5,1.5,1.5h4.8c0,4.1-2.5,5.7-5.9,5.7
			c-3.5,0-5.9-2-5.9-5.4V13.9c0-3.4,2.4-5.8,5.9-5.8c3.6,0,5.5,1.6,6.1,3.2c0.3,0.8,0,1.8,1.5,1.8h4h1.1c0.8,0,1.2-0.1,1.4-0.5
			c0.1-0.2,0.2-0.5,0.2-1c0-7.1-7.7-11-14.3-11c-6.3,0-14.3,3.6-14.3,12v4.1v9c0,8.4,8,11.6,14.3,11.6c6.1,0,13.9-3.4,14.3-11.1
			v-7.7C360.2,17.6,359.9,17,358.7,17z"
        />
        <path
          className="st2"
          d="M26.4,18.4c0.3-0.2,2-1,3.1-3.2c0.6-1.1,1-2.6,1-4.5c0-5.2-3.9-10.1-13-10.1H9H1.8c-1.3,0-1.6,0.6-1.6,1.6
			v7.3v26.3c0,1,0.3,1.6,1.6,1.6h16.1h0.3c7.8,0,13.3-3.6,13.3-10.7C31.5,20.6,26.8,18.5,26.4,18.4z M18.3,29.5h-0.4H9V11.7V8.5l0,0
			h8.5c2.9,0,4.6,0.6,4.6,3.1c0,1-0.3,1.8-0.9,2.3s-1.5,0.9-2.8,1c-0.3-0.7-0.9-1.2-1.8-1.2s-1.6,0.6-1.8,1.4c0,0.2-0.1,0.3-0.1,0.5
			c0,0.4,0.1,0.7,0.3,1l0,0c0.1,0.2,0.1,0.4,0.2,0.7c0.2,1.1,0.1,2,0,2.7c-0.1,0.5-0.2,0.8-0.2,0.8l0,0l0,0
			c-0.1,0.2-0.2,0.3-0.2,0.5s-0.1,0.3-0.1,0.5c0,1,0.8,1.9,1.9,1.9c0.8,0,1.5-0.5,1.8-1.2c2.6,0,4.4,0.8,4.4,3.4
			C22.6,28.4,21.1,29.5,18.3,29.5z M16.5,16.5c-0.5,0-0.9-0.4-0.9-1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0.2-0.3,0.5-0.5,0.9-0.5
			c0.3,0,0.5,0.1,0.7,0.3s0.2,0.4,0.2,0.7c0,0.1,0,0.2,0,0.2C17.4,16.2,17,16.5,16.5,16.5z M17.4,21.7c0,0.1,0,0.2,0,0.2
			c0,0.2-0.2,0.4-0.3,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.6-0.2-0.8-0.4c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.1,0-0.2,0-0.2
			c0.1-0.4,0.5-0.7,0.9-0.7C17,20.8,17.4,21.2,17.4,21.7z"
        />
      </g>
      <g className="st1">
        <path
          className="st2"
          d="M375,29.7v6.2c0,1.3-0.6,1.6-1.6,1.6h-6.1c-1,0-1.6-0.3-1.6-1.6v-6.2c0-1.3,0.6-1.6,1.6-1.6h6.1
			C374.4,28.1,375,28.4,375,29.7z"
        />
        <path
          className="st2"
          d="M411.2,13.4V25c0,8.7-8.3,12.5-14.9,12.5h-12.4c-1.3,0-1.6-0.6-1.6-1.6V2.6c0-1,0.3-1.6,1.6-1.6h12.4
			C402.9,1,411.2,4.8,411.2,13.4z M402.5,14.2c0-3.5-2.5-5.5-6.2-5.5H391v21h5.3c3.6,0,6.2-2,6.2-5.5V14.2z"
        />
        <path
          className="st2"
          d="M446.3,31.3v4.5c0,1-0.3,1.6-1.6,1.6h-24.8c-1.3,0-1.6-0.6-1.6-1.6V2.6c0-1,0.3-1.6,1.6-1.6h23.9
			c1.3,0,1.6,0.6,1.6,1.6v4.6c0,1-0.3,1.6-1.6,1.6H427v6h14.8c1.3,0,1.6,0.6,1.6,1.6v4.3c0,1-0.3,1.6-1.6,1.6H427v7.3h17.7
			C445.9,29.7,446.3,30.3,446.3,31.3z"
        />
      </g>
    </g>
    <g>
      <path
        className="st2"
        d="M16.3,14.5c-0.4,0-0.7,0.2-0.9,0.5c0,0.1-0.1,0.1-0.1,0.2s0,0.2,0,0.2c0,0.5,0.4,1,0.9,1
		c0.4,0,0.8-0.3,0.9-0.7c0-0.1,0-0.2,0-0.2c0-0.3-0.1-0.5-0.2-0.6C16.8,14.7,16.6,14.5,16.3,14.5z"
      />
      <path
        className="st2"
        d="M16.2,20.7c-0.4,0-0.8,0.3-0.9,0.7c0,0.1,0,0.2,0,0.2c0,0.2,0.1,0.4,0.1,0.5c0.2,0.3,0.5,0.4,0.8,0.4
		c0.2,0,0.4-0.1,0.6-0.2s0.3-0.3,0.3-0.5c0-0.1,0-0.2,0-0.2C17.1,21.1,16.7,20.7,16.2,20.7z"
      />
      <path
        className="st2"
        d="M52.9,29.8h-3.5V17.5V8.6h3.3C54,8.6,54.3,8,54.3,7V2.5c0-1-0.3-1.6-1.6-1.6H37.2c-1.3,0-1.6,0.6-1.6,1.6V7
		c0,1,0.3,1.6,1.6,1.6h3.4v7.9v13.3h-3.5c-1.3,0-1.6,0.6-1.6,1.6v4.4c0,1,0.3,1.6,1.6,1.6h15.7c1.3,0,1.6-0.6,1.6-1.6v-4.4
		C54.5,30.5,54.1,29.8,52.9,29.8z"
      />
      <path
        className="st2"
        d="M92.1,0.9h-7.5c-1.3,0-1.7,0.1-2.8,1.3L70.3,14.9V2.5c0-1.3-0.6-1.6-1.6-1.6h-5.5c-1.1,0-1.6,0.3-1.6,1.6v16.1
		v17.2c0,1.3,0.6,1.6,1.6,1.6h5.6c0.9,0,1.6-0.3,1.6-1.6v-9.9l3.4-3.6c3,5,8,13.4,8,13.4c0.7,1.2,1.4,1.8,2.8,1.8h6.8
		c1.1,0,1.3-1.1,0.8-1.8l-9.4-15.5L80.2,16L92.7,2.4C93.2,1.9,93.2,0.9,92.1,0.9z"
      />
      <path
        className="st2"
        d="M123.4,29.7h-17.7v-7.3h14.9c0.4,0,0.7-0.1,0.9-0.2c0.5-0.2,0.7-0.8,0.7-1.4v-4.4c0-1-0.3-1.6-1.6-1.6h-14.9
		V8.7h16.8c1.3,0,1.6-0.6,1.6-1.6V2.5c0-1-0.3-1.6-1.6-1.6h-24c-1.3,0-1.6,0.6-1.6,1.6v18.6v14.8c0,1,0.3,1.6,1.6,1.6h24.9
		c1.3,0,1.6-0.6,1.6-1.6v-4.6C125,30.3,124.7,29.7,123.4,29.7z"
      />
      <path
        className="st2"
        d="M156.5,29.7h-16v-6.9V2.5c0-1.3-0.6-1.6-1.6-1.6h-5.5c-1,0-1.6,0.3-1.6,1.6v20v13.3c0,1,0.3,1.6,1.6,1.6h23.1
		c1.3,0,1.6-0.6,1.6-1.6v-4.6C158.1,30.3,157.8,29.7,156.5,29.7z"
      />
      <path
        className="st2"
        d="M190.7,29.7H173v-6.4v-0.9h14.8c1.3,0,1.6-0.6,1.6-1.6v-4.4c0-1-0.3-1.6-1.6-1.6h-14.9V8.7h16.8
		c1.3,0,1.6-0.6,1.6-1.6V2.5c0-1-0.3-1.6-1.6-1.6h-24c-1.3,0-1.6,0.6-1.6,1.6v20.7v12.7c0,1,0.3,1.6,1.6,1.6h24.9
		c1.3,0,1.6-0.6,1.6-1.6v-4.6C192.3,30.3,192,29.7,190.7,29.7z"
      />
      <path
        className="st2"
        d="M230.5,35.9l-4.8-13l-7.5-20.4c-0.5-1.2-1.1-1.7-2.3-1.7h-5.3c-1.2,0-1.8,0.6-2.3,1.7l-7.7,20.7l-4.7,12.6
		c-0.3,0.7-0.3,1.6,0.9,1.6h5.8c1.2,0,1.7-0.3,2.1-1.7l1.6-4.4h13.6l1.6,4.4c0.4,1.3,0.9,1.7,2.1,1.7h5.8
		C230.8,37.5,230.8,36.6,230.5,35.9z M213.3,11.3l4,11.8l-8,0.1L213.3,11.3z"
      />
      <path
        className="st2"
        d="M261.5,21.6c-1.8-3.4-5.6-4.5-8.5-5.4c-2.1-0.9-10-2-10-5.3c0-2.4,2.9-3.1,4.7-3.1c1.6,0,3.5,0.5,4.5,1.4
		c0.6,0.6,0.9,1.1,1.1,1.6c0.3,0.7,0.4,1.4,1.4,1.4h5.2c1.2,0,1.5-0.2,1.5-1.5c0-7.1-7.4-10.2-14.2-10.2c-6.7,0.3-13,3.7-13,10.6
		c0,6.8,5,8.9,10.4,10.6c0.3,0.1,0.5,0.2,0.8,0.2c4.3,1.2,8.5,1.4,8.5,4.2c0,3-2.4,3.6-5.2,3.6c-2,0-4.2-0.5-5.2-1.8
		c-0.7-0.8-1-1.5-1-2.2c-0.1-1.3-0.7-1.5-1.9-1.5h-5.2c-1.2,0-1.5,0.3-1.5,1.5c0,7.5,7.7,11.3,14.4,11.3c8.2,0,14.2-3.6,14.2-11.2
		C262.5,24.3,262.1,22.8,261.5,21.6z"
      />
      <path
        className="st2"
        d="M285.6,29.8h-3.5v-9V8.6h3.3c1.3,0,1.6-0.6,1.6-1.6V2.5c0-1-0.3-1.6-1.6-1.6h-15.5c-1.3,0-1.6,0.6-1.6,1.6V7
		c0,1,0.3,1.6,1.6,1.6h3.4v12.7v8.6h-3.5c-1.3,0-1.6,0.6-1.6,1.6v4.4c0,1,0.3,1.6,1.6,1.6h15.7c1.3,0,1.6-0.6,1.6-1.6v-4.4
		C287.2,30.5,287,29.8,285.6,29.8z"
      />
      <path
        className="st2"
        d="M322.6,0.9h-5.3c-1,0-1.6,0.3-1.6,1.6v15.9v3.4l-2-3.2l-9.8-15.8c-0.7-1.1-1.1-1.9-2.5-1.9h-5.2
		c-1.3,0-1.6,0.6-1.6,1.6v17.6v15.8c0,1.3,0.6,1.6,1.6,1.6h5.5c1,0,1.6-0.3,1.6-1.6V19.4v-2.9l1.7,2.8l10.1,16.3
		c0.7,1.1,1.1,1.9,2.5,1.9h5.1c1.3,0,1.6-0.6,1.6-1.6V17.6V2.5C324.1,1.2,323.6,0.9,322.6,0.9z"
      />
      <path
        className="st2"
        d="M358.5,16.9h-11.7c-1.2,0-1.5,0.6-1.5,1.5v4.2c0,1,0.3,1.5,1.5,1.5h4.8c0,4.1-2.5,5.7-5.9,5.7
		c-3.5,0-5.9-2-5.9-5.4V13.8c0-3.4,2.3-5.8,5.9-5.8s5.5,1.6,6.1,3.3c0.3,0.7,0.1,1.8,1.5,1.8h4h1.1c0.8,0,1.2-0.1,1.4-0.5
		c0.1-0.2,0.2-0.6,0.2-1c0-7.1-7.7-11-14.3-11c-6.3,0-14.3,3.6-14.3,12v4.1v9c0,8.4,8,11.6,14.3,11.6c6.1,0,13.9-3.4,14.3-11.1v-7.7
		C360,17.5,359.6,16.9,358.5,16.9z"
      />
      <path
        className="st2"
        d="M26.1,18.3c0.3-0.1,2-1,3.1-3.2c0.6-1.1,1-2.6,1-4.5c0-5.3-3.9-10.1-13-10.1H8.7H1.5c-1.3,0-1.6,0.6-1.6,1.6
		v7.3v26.3c0,1,0.3,1.6,1.6,1.6h16.1h0.3c7.8,0,13.3-3.6,13.3-10.7C31.2,20.6,26.5,18.4,26.1,18.3z M18,29.4h-0.4h-9V11.6V8.4l0,0
		h8.5c2.9,0,4.6,0.6,4.6,3.1c0,1-0.3,1.8-0.9,2.3c-0.6,0.6-1.5,0.9-2.8,1c-0.3-0.7-0.9-1.2-1.7-1.2c-0.9,0-1.6,0.6-1.9,1.4
		c0,0.2-0.1,0.3-0.1,0.5c0,0.4,0.1,0.7,0.3,1l0,0c0.1,0.2,0.1,0.4,0.2,0.7c0.2,1.1,0.1,2.1,0,2.7c-0.1,0.5-0.2,0.8-0.2,0.8l0,0l0,0
		c-0.1,0.1-0.2,0.3-0.2,0.5s-0.1,0.3-0.1,0.5c0,1,0.8,1.9,1.9,1.9c0.8,0,1.5-0.5,1.8-1.2c2.6,0,4.4,0.8,4.4,3.4
		C22.4,28.3,20.8,29.4,18,29.4z M16.3,16.4c-0.5,0-0.9-0.4-0.9-1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0.2-0.3,0.5-0.5,0.9-0.5
		c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.2,0.6c0,0.1,0,0.2,0,0.2C17.1,16.1,16.7,16.4,16.3,16.4z M17.1,21.6c0,0.1,0,0.2,0,0.2
		c-0.1,0.2-0.2,0.4-0.3,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.6-0.2-0.8-0.4c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.1,0-0.2,0-0.2
		c0.1-0.4,0.5-0.7,0.9-0.7C16.7,20.7,17.1,21.1,17.1,21.6z"
      />
    </g>
    <g>
      <path
        className="st2"
        d="M374.8,29.6v6.1c0,1.3-0.6,1.6-1.6,1.6H367c-1,0-1.6-0.3-1.6-1.6v-6.1c0-1.3,0.6-1.6,1.6-1.6h6.1
		C374.1,28,374.8,28.3,374.8,29.6z"
      />
      <path
        className="st2"
        d="M412.5,37.3h-5.8c-1.2,0-1.7-0.3-2.1-1.7l-1.6-4.4h-13.6l-1.6,4.4c-0.4,1.3-0.9,1.7-2.1,1.7h-5.8
		c-1.2,0-1.2-0.9-0.9-1.6l12.3-33.2c0.4-1.2,1.1-1.7,2.3-1.7h5.3c1.2,0,1.8,0.6,2.3,1.7l12.2,33.2C413.6,36.4,413.6,37.3,412.5,37.3
		z M400.4,23.5l-4.2-12.2l-4.2,12.2C391.9,23.5,400.4,23.5,400.4,23.5z"
      />
      <path
        className="st2"
        d="M442.1,2.5v4.6c0,1-0.3,1.6-1.6,1.6H432v27c0,1.3-0.6,1.6-1.6,1.6h-5.5c-1,0-1.6-0.3-1.6-1.6v-27h-8.5
		c-1.3,0-1.6-0.6-1.6-1.6V2.5c0-1,0.3-1.6,1.6-1.6h25.7C441.8,0.9,442.1,1.5,442.1,2.5z"
      />
    </g>
  </svg>
);
